<fgb-account-layout [isProfilePage]="isProfilePage" [titleKey]="titleKey" [titleDefault]="titleDefault">
  <fgb-account-details></fgb-account-details>
</fgb-account-layout>
